import {sandbox, locations} from '@servicenow/ui-internal';
import {camelCaseProperties, unescapeReservedCharacters, resolveComputedProperties} from '../utils';
import reflectProperties from './reflectProperties';
import log from '../log';

export {reflectProperty} from './reflectProperties';

export default function shapeRenderData(
	state,
	host,
	hostVariables,
	transform,
	dispatch,
	interactionId
) {
	const transformedState = reflectProperties(
		unescapeReservedCharacters(
			resolveComputedProperties(camelCaseProperties(state), host, hostVariables, interactionId)
		),
		host,
		interactionId
	);

	return (
		sandbox(transform, {
			args: [transformedState],
			host,
			location: locations.TRANSFORM_STATE,
			dispatch,
			log
		}) || transformedState
	);
}
